import {StoreState} from '@/app/store';

export const selectLocationFullName = (state: StoreState) => {
	if (!state.maps.data) {
		return undefined;
	}

	const {title, description} = state.maps.data?.location;
	return description ? `${title}, ${description}` : title;
};

export const selectMapsData = (state: StoreState) => state.maps.data;
export const selectMapLocationId = (state: StoreState) => state.maps.data?.location.id;
export const selectMapLocationAlternateIds = (state: StoreState) => state.maps.data?.locationMeta?.alternateIds;
export const selectMapCountryStableId = (state: StoreState) => state.maps.data?.locationMeta?.countryStableId;
